<section id="profile-info">
    <div class="row">
        <div class="col-lg-12 col-12 order-1 order-lg-2">
            <div class="form-group mb-2">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h2>Admission Process</h2>
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-sm btn-outline-primary"
                                    (click)="addEditorBlock('content')">
                                Content
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-primary"
                                    (click)="addEditorBlock('table')">
                                Table
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <ng-container *ngFor="let block of editorBlocks; let i = index">
                            <div class="d-flex justify-content-end mb-1">
                                <button class="btn btn-icon btn-flat-danger" rippleEffect type="button"
                                        title="Remove" (click)="removeEditorBlock(i)">
                                    <i data-feather="trash-2"></i>
                                </button>
                            </div>
                            <quill-editor *ngIf="block.type === 'content'" class="university-info mb-3"
                                          [(ngModel)]="block.value" name="quill-content-{{i}}"></quill-editor>

                            <div *ngIf="block.type === 'table'" class="mb-3">
                                <editor [apiKey]="tinymceApiKey" [(ngModel)]="block.value" [init]="tableEditorInit"
                                        name="table-content-{{i}}"></editor>
                            </div>
                        </ng-container>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary pull-right" rippleEffect [disabled]="submitting" (click)="submit()">
                            <i data-feather="check" class="d-block d-md-none"></i>
                            <span class="font-weight-bold d-none d-md-block">{{submitting ? 'Saving...' : 'Submit'}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
